import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { DependencyMapClient, dependencyMapApiRef } from './api';
import { rootRouteRef } from './routes';

export const dependencyMapPlugin = createPlugin({
  id: 'dependency-map',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: dependencyMapApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new DependencyMapClient({ discoveryApi, fetchApi }),
    }),
  ],
});

export const DependencyMapPage = dependencyMapPlugin.provide(
  createRoutableExtension({
    name: 'DependencyMapPage',
    component: () =>
      import('./components/DependencyMapPage').then(m => m.DependencyMapPage),
    mountPoint: rootRouteRef,
  }),
);
